const USER_LIST_QUERY_KEYS = [
	'page',
	'limit',
	'search',
	'search_key',
	'search_field',
	'status',
]

/** Builds the Users route state in one update, so tab selection has one source of truth. */
export const buildUsersTabSearchParams = (
	searchParams: URLSearchParams,
	nextTab: string,
) => {
	const nextSearchParams = new URLSearchParams(searchParams)

	if (nextTab !== 'user') {
		USER_LIST_QUERY_KEYS.forEach((key) => nextSearchParams.delete(key))
	}

	nextSearchParams.set('tab', nextTab)
	return nextSearchParams
}
